<div class="flex flex-row justify-center lg:justify-between bg-primary py-[5%] px-10 h-full w-full">
  <div class="text-white pt-6">
    <div>
      <div class="text-[42px] font-bold leading-[3.2rem] mx-8 mt-2 max-xsm:text-[30px] max-xsm:leading-8 max-xsm:mx-0">
        Ready to book your<br />
        next project?
      </div>
      <div class="mx-8 mt-8 mb-2 leading-7 text-lg max-xsm:leading-6 max-xsm:mx-0">
        If you are a Forsta customer please create an account.<br />
        Otherwise continue as a guest to try out our services.
      </div>
    </div>
    <div class="flex flex-col">
      <a
        routerLink="/booking/"
        title="continue as guest"
        class="btn btn-outline btn-lg max-w-md max-lg:max-w-4xl mx-8 my-2 font-bold uppercase text-accent-blue border-2 text-xl hover:bg-accent-blue hover:text-primary hover:border-accent-blue max-xsm:mx-0 max-xsm:btn-md max-xsm:text-xs h-auto md:max-h-16"
        >continue as guest</a
      >
      <a
        (click)="signup()"
        title="create an account"
        class="btn btn-outline btn-lg max-w-md max-lg:max-w-4xl mx-8 my-2 font-bold uppercase text-accent-blue border-2 text-xl hover:bg-accent-blue hover:text-primary hover:border-accent-blue max-xsm:mx-0 max-xsm:btn-md max-xsm:text-xs h-auto md:max-h-16"
        >create an account</a
      >
    </div>
  </div>
  <div class="max-w-screen-lg hidden lg:block">
    <img src="../../assets/InterVu_Stimulus_Macbook_Air_02.webp" class="w-[850px]" />

    <div class="text-center mb-2">
      <div class="text-[2.6rem] font-light mb-1 leading-[3.4rem] text-white">Flexible online focus group software</div>
      <div class="text-[20px] font-light text-white mb-7 leading-7">
        Present stimuli, share screens, mark-up screens, polls and more in your online focus groups
      </div>
      <a
        href="https://www.forsta.com/platform/digital-interviews/"
        class="btn btn-outline bg-accent-blue text-primary border-accent-blue hover:bg-transparent hover:text-accent-blue hover:border-accent-blue"
        >Request a demo</a
      >
    </div>
  </div>
</div>
<div class="relative hidden lg:block">
  <div class="absolute bottom-0 right-0 w-[25%]">
    <div class="bg-secondary h-14"></div>
  </div>
</div>
